import { BerriesPerClusterFilter } from '../../../../services/data/impl/wrangler/schemas/clusterReportRequest';

/**
 *
 * Converts dropdown value to BerriesPerClusterFilter object
 *
 * @param {string} value - value from BerriesPerClusterDropdown in the format '[num][+/-]' ex. '20+'
 * @returns filter object to include in Wrangler request body
 */
export const useBerriesPerClusterFilter = (
  value: string
): BerriesPerClusterFilter => {
  if (value === 'all') {
    return {
      value: 0,
      comparison: '>=',
    };
  }

  const [numBerries, operation] = value.split(/(\+|-)/, 2);

  return {
    value: Number(numBerries),
    comparison: operation === '+' ? '>=' : '<',
  };
};
